import { type ReactElement } from "react";
import {
  Button,
  ButtonType,
  Text,
} from "syngenta-digital-cropwise-react-ui-kit";
import { useTranslation } from "react-i18next";

import { formatTranslation } from "../../shared/utils/translationUtils";
import { useSafeNavigate } from "../../shared/custom-hooks/useSafeNavigate";
import PageNotFoundSvg from "../../assets/404_illustration.svg";
import "./pageNotFound.less";

/**
 * page not found component
 * @returns
 */
const PageNotFound = (): ReactElement => {
  const { t } = useTranslation();
  const navigate = useSafeNavigate();

  return (
    <div className="page-not-found-container">
      <img src={PageNotFoundSvg} alt="page not found" />
      <div className="page-not-found-text">
        <Text className="page-not-found-title">
          {formatTranslation(t("pageNotFound.title"))}
        </Text>
        <Text className="page-not-found-helper">
          {formatTranslation(t("pageNotFound.subTitle"))}
        </Text>
      </div>
      <Button
        className="back-home-btn"
        size="large"
        type={ButtonType.primary}
        onClick={() => {
          navigate("/");
        }}
      >
        {formatTranslation(t("pageNotFound.back_home"))}
      </Button>
    </div>
  );
};

export default PageNotFound;
